export default `query getCategoryDescriptionList($limit: Int, $offset: Int, $keyword: String $language_code: String){
  getCategoryDescriptionList(limit: $limit, offset: $offset, keyword: $keyword language_code: $language_code) {
    count
    data {
      category_id
      title
    }
  }
}`;
